// extracted by mini-css-extract-plugin
export default {"logo":"IsN9Lp5CsBc26fLHTjZM7Q=="};